import { Injectable } from "@angular/core";
import { AuthRepository } from "../repository/auth.repository";
import { BehaviorSubject, Observable, tap } from "rxjs";
import { Router } from "@angular/router";
import { LoginRequest } from "../models/login.model";
import { LoginResponse } from "../models/login.model";

@Injectable({providedIn: 'root'})
export class AuthService {
    private userSubject=new BehaviorSubject<any>(
        localStorage.getItem('user')? JSON.parse(localStorage.getItem('user')!) : null
    );
    public user=this.userSubject.asObservable();

    constructor(
        private authRepo: AuthRepository,
        private router: Router
    ){}

    public get userValue(){
        return this.userSubject.value;
    }

    // login(email:string, password:string){
    //     return this.authRepo.login(email,password).pipe(
    //         tap(user => this.setUser(user))
    //     );
    // }
     login(request: LoginRequest): Observable<LoginResponse> {
    return this.authRepo.login(request);
  }

    setUser(user:any){
        localStorage.setItem('user',JSON.stringify(user));
        localStorage.setItem('token',user.bearer_Token);
        this.userSubject.next(user);
    }

    logout(){
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        this.userSubject.next(null);
    this.router.navigate(['/auth/login']);

    }

    isLoggedIn(){
        const token =localStorage.getItem('token');
        const user=this.userValue;
        // if(!token || !user) return false;
        if(!token ) return false;

        
        // const expiratinDate = new Date(user.expire_token);
        // if(new Date() > expiratinDate) {
        //     this.logout();
        //     return false;
        // }
        return true;

    }

    hasPermission(permission: string){
        return this.userValue.permissions?.includes(permission);
    }

    isSuperAdmin(){
        return this.userValue.is_Super;
    }
}
